import { requestWithAbort, type RequestResponse } from '@atlassian/twg-common/request';

export type NoDataResponse = {
	status: 'NO_DATA';
	organisationId: string;
};

export type OrgMetricsResponse = {
	organisationId: string;
	totalRelationships: number | null;
	activeRelTypes: number | null;
	jiraCodeLinks: number | null;
	goalWorkItemLinks: number | null;
	relDataAsOf: string | null;
	computedAt: string | null;
	cacheStatus: string | null;
	avgDailyRelChange: number | null;
	avgRelChangePerSecond: number | null;
	avgDailyJiraCodeLinkChange: number | null;
	avgJiraCodeLinkChangePerSecond: number | null;
	totalJiraIssues: number | null;
	avgArtifactsPerIssue: number | null;
	totalNodes: number | null;
	activeNodeTypes: number | null;
	teamCount: number | null;
	userCount: number | null;
	nodeDataAsOf: string | null;
	avgDailyNodeGrowth: number | null;
	avgNodeGrowthPerSecond: number | null;
	daysSinceSnapshot: number | null;
	estimatedNodesNow: number | null;
	activeContributors180d: number | null;
	activityDataAsOf: string | null;
	avgFetchQueriesPerDay: number | null;
	avgFetchQueriesPerSecond: number | null;
	queryDataAsOf: string | null;
	pagesCreated180d: number | null;
	pagesDataAsOf: string | null;
	loomsRecorded180d: number | null;
	totalMinutesRecorded: number | null;
	meetingMinutesSaved: number | null;
	loomDataAsOf: string | null;
	issuesMovedForward180d: number | null;
	issueActivityDataAsOf: string | null;
	commentsCreated180d: number | null;
	commentsDataAsOf: string | null;
	meetingNotesWithRecording180d: number | null;
	meetingNotesDataAsOf: string | null;
	connectorObjects180d: number | null;
	connectorDataAsOf: string | null;
	connectorObjectsByProvider: Array<{
		providerName: string;
		objects30d: number;
	}> | null;
	smartlinkPastes180d: number | null;
	smartlinkDataAsOf: string | null;
	connectorsInstalled: number | null;
	connectorsActive28d: number | null;
	pctConnectorsActive28d: number | null;
	onePAppsInstalled: number | null;
	marketplaceAddonsInstalled: number | null;
	threePConnectorsInstalled: number | null;
	forgeAppsInstalled: number | null;
	totalAppsInstalled: number | null;
	connectorsDetail: Array<{
		connectorName: string;
		connectorCategory: string;
		pctUsersAuthed28d: number;
		isUnderutilised: boolean;
		globalPctOrgsWithAnyAuthedUser: number;
	}> | null;
	entitiesTouched: number | null;
	collaborators: number | null;
	collaboratorTeams: number | null;
	collaboratorTeamsTruncated: boolean | null;
};

export const requestOrgMetrics = (
	orgId: string,
	cloudId: string,
	accountId?: string,
): {
	controller: AbortController;
	execute: Promise<RequestResponse<OrgMetricsResponse | NoDataResponse>>;
} => {
	const headers: Record<string, string> = {
		'X-Query-Context': `ari:cloud:platform::site/${cloudId}`,
	};
	if (accountId) {
		headers['x-user-id'] = accountId;
		headers['x-cloudid'] = cloudId;
	}

	const { controller, execute } = requestWithAbort<OrgMetricsResponse | NoDataResponse>(
		'GET',
		`/gateway/api/twg-api/v1/microsite/metrics/org/${orgId}`,
		null,
		headers,
		[200, 404],
	);
	return { controller, execute };
};
